module.exports = __webpack_public_path__ + "static/the-ui-dev-4258bb35d6c92793327196411ce07c86.png";